/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input, Output, Inject, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IcecontrolSettings, iceColumnDefinition, IcecontrolPermission } from '../../components/models/icesettings';
import { IcepanelComponent } from '../icepanel/icepanel.component';
import { orderobject } from '../../models/domain/order';
import { orderdetailobject } from '../../models/domain/orderdetail';
import { Iceutility } from '../../services/iceutility';
@Component({
  selector: 'icepaymentreceipt',
  templateUrl: './icepaymentreceipt.component.html',
  styleUrls: ['./icepaymentreceipt.component.scss']
})
export class IcepaymentreceiptComponent implements OnInit {
  // Input Members
	@Input() placeholder: string;
  @Input() properties: any;
  @Input() ctrl: IcecontrolSettings = null;

  // Output Members
  @Output() buttonClick: EventEmitter<any> = new EventEmitter<any>();

  // Data Members
  iceFormControl: FormControl = null;

  constructor(@Inject(IcepanelComponent) private parent: IcepanelComponent) {
	}

	ngOnInit() {
    try {
      // stardard formcontrol processing
      if (this.ctrl != null)
        this.iceFormControl = this.ctrl.getFormControl();

      if (this.iceFormControl == null)
        this.iceFormControl = new FormControl(false); // No control so we create a placeholder control to prevent an errors
    }
    catch (e) {
      console.log(e);
    }
  }

  ////////////////////////////////////
  // Company
  getCompanyName(): string {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    val = this.ctrl.properties.companyName;
    return val;
  }

  getCompanyCountry() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    val = this.ctrl.properties.companyCountry;
    return val;
  }

  getCompanyPhone() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    val = this.ctrl.properties.companyPhone;
    return val;
  }

  getOrderNumber() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    val = order != null && order.order_key != null ? order.order_key.toUpperCase().substr(0, 7) : "";
    return val;
  }

  getNetworkID() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    val = order != null && order.trans_account != null ? order.trans_account.toUpperCase() : "";
    return val;
  }

  getMemberID() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    val = order != null && order.login_user_name != null ? order.login_user_name.toUpperCase() : "";
    return val;
  }

  getTotal() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    val = order != null && order.total != null ? order.total.toString() : "0";
    let curcy = order != null && order.customer_currency_code != null ? order.customer_currency_code : "";
    return val + " " + curcy;
  }

  getSubTotal() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    val = order != null && order.sub_total != null ? order.sub_total.toString() : "0";
    let curcy = order != null && order.customer_currency_code != null ? order.customer_currency_code : "";
    return val + " " + curcy;
  }

  getOtherFees() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    val = order != null && order.other_fees != null ? order.other_fees.toString() : "0";
    let curcy = order != null && order.customer_currency_code != null ? order.customer_currency_code : "";
    return val + " " + curcy;
  }

  ////////////////////////////////////
  // Customer
  getCustomerContactName() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    val = order != null && order.customer_contact_name != null ? order.customer_contact_name : "";
    return val;
  }

  getCustomerCompanyName() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    val = order != null && order.customer_company_name != null ? order.customer_company_name : "";
    return val;
  }

  getCustomerAddress() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    val = order != null && order.customer_address != null ? order.customer_address : "";
    return val;
  }

  getCustomerCity() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    val = order != null && order.customer_city != null ? order.customer_city : "";
    return val;
  }

  getCustomerState() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    val = order != null && order.customer_state != null ? order.customer_state : "";
    return val;
  }

  getCustomerPostalCode() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    val = order != null && order.customer_postal_code != null ? order.customer_postal_code : "";
    return val;
  }

  getCustomerCountry() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    val = order != null && order.customer_country_code != null ? order.customer_country_code : "";
    return val;
  }

  getCustomerPhone() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    val = order != null && order.customer_phone != null ? order.customer_phone : "";
    return val;
  }

  getCustomerEmail() {
    let val = "";
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null) {
      return val;
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    val = order != null && order.customer_email != null ? order.customer_email : "";
    return val;
  }

  getPurchaseOptions(): any[] {
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null || this.ctrl.properties.orderInformation == null) {
      return [];
    }

    let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
    if (order) {
      return order.ORDER_DETAILS;
    }

    return [];
  }

  getPurchaseOption(opt: any, attr: string): string {
    let ordDetail: orderdetailobject = opt;
    if (ordDetail == null || ordDetail.SUBSCRIPTOBJ == null || ordDetail.SUBSCRIPTOBJ.length == 0) return "";

    let sub = ordDetail.SUBSCRIPTOBJ[0];
    if (sub == null) return "";

    let val = "";
    switch (attr) {
      case "title": {
        val = sub.title;
        break;
      }
      case "intro": {
        val = sub.introduction;
        break;
      }
      case "price": {
        let curcy = "";
        let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
        if (order) {
          curcy = order.customer_currency_code; 
        }

        val = opt.price.toString() + " " + curcy; // currency comes from the order
        break;
      }
    }
    return val;
  }

  getTransactionDetail(attr: string): string {
    debugger;
    if (this.ctrl == null || this.ctrl.properties == null || this.ctrl.properties == null
      || this.ctrl.properties.transactionInformation == null || this.ctrl.properties.transactionInformation.transactionResponse == null) {
      return "";
    }

    let transRes = this.ctrl.properties.transactionInformation.transactionResponse;

    let val = "";
    switch (attr) {
      case "transId":
      case "authCode": {
        val = transRes[attr];
        break;
      }
      case "transType":
      case "date": {
        if (this.ctrl.properties.orderInformation == null)
          return "";

        let order: orderobject = <orderobject>this.ctrl.properties.orderInformation;
        if (order && order.PAYMENT_REQUEST != null && order.PAYMENT_REQUEST.length > 0 && attr == "transType") {
          val = order.PAYMENT_REQUEST[0].transactiontype;
        }
        else if (order && attr == "date") {
          val = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(order.date));
        }
        break;
      }
      case "transStatus": {
        let msgs = transRes["messages"];
        if (msgs != null && msgs.length > 0) {
          val = msgs[0].description + " (" + msgs[0].code + ") ";
        }
        break;
      }
      case "paymentMethod": {
        val = transRes["accountType"] + ", " + transRes["accountNumber"];
        break;
      }      
    }
    return val;
  }

  getLicenseLimits(opt: any): string[] {
    let ordDetail: orderdetailobject = opt;
    if (ordDetail == null || ordDetail.SUBSCRIPTOBJ == null || ordDetail.SUBSCRIPTOBJ.length == 0) return [];

    let sub = ordDetail.SUBSCRIPTOBJ[0];
    if (sub == null) return [];

    return sub.getSummary();
  }

  onPrint(event) {
    document.getElementById('printlink').style.visibility = 'hidden';
    document.getElementById('closelink').style.visibility = 'hidden';
    window.print();
    window.close();

    setTimeout(() => {
      document.getElementById('printlink').style.visibility = 'visible';
      document.getElementById('closelink').style.visibility = 'visible';
    }, 500);
  }

  onClose(event) {
    event.buttonSettings = this.ctrl;
    event.buttonAction = "CloseReceipt";

    if (this.parent && this.parent.controlClick)
      this.parent.onControlClick(event);
    else
      this.buttonClick.emit(event);
  }
}
